import { render, staticRenderFns } from "./CardProducts.vue?vue&type=template&id=a5444928&scoped=true&"
import script from "./CardProducts.vue?vue&type=script&lang=js&"
export * from "./CardProducts.vue?vue&type=script&lang=js&"
import style0 from "./CardProducts.vue?vue&type=style&index=0&id=a5444928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5444928",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VFlex,VImg,VLayout})
